
let listeners = {};
const actionEventMiddleWare = store => next => action => {    
    let result = next(action);
    if(listeners[action.type])
    {
        listeners[action.type].callback();
        if(listeners[action.type].deleteAfterFirstCall)
        {
            delete listeners[action.type];
        }
    }
    return result;
}
actionEventMiddleWare.addListener = (action,callback,deleteAfterFirstCall) =>
{
    listeners[action] = {callback,deleteAfterFirstCall}

}

export default actionEventMiddleWare



    
